import { useState } from 'react';
import {isMobile} from 'react-device-detect'
import utils from '../utils';

const StatusInfo = (props) => {

  const [displayHistory, setDisplayHistory] = useState(false)
    
  const handleDisplayHistory = (displayHistory) => {
    setDisplayHistory(!displayHistory)
  }	

  let {statusInfo} = props

  if(!statusInfo || statusInfo.length === 0)
    statusInfo = []

  return (
     <section>
        <div className="card secondary" id="status_info">
          
          <div style={{textAlign : isMobile ? "center" : "right"}} >
           
            <button  onClick = {() => handleDisplayHistory(displayHistory)}>
              {displayHistory ? "[-] Less details" : "[+] More details"}
            </button> 	 
          
           
          </div>

          {displayHistory &&

            <div id="Status_history_table" >  

              <h3>Status history</h3>

                <table className="" >
                  <thead>
                    <tr>
                      <th>Status </th>
                      <th>Airport</th>
                      <th>Details</th>
                      <th>Local Time</th>
                      <th>UTC Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {statusInfo.map((fsu) => {
                      let detailString = ""
                                  
                      if(fsu.status)
                        detailString = utils.mapStatus(fsu);

                      let time = !fsu.event_date ? "" :  utils.convertDate(fsu.event_date , true)
                      let time_utc = !fsu.event_date_utc ? "" :  utils.convertDate(fsu.event_date_utc, true);
                                  
                      if(isMobile){
                        time = <span> {time.split("|")[0]} <br/> {time.split("|")[1]} </span> ; 
                        time_utc = <span> {time_utc.split("|")[0]} <br/> {time_utc.split("|")[1]}</span>; 
                      }
                                        
                      return (
                        <tr>
                          <td>{fsu.status} </td>
                          <td>{fsu.airport}</td>          
                          <td>{detailString}</td>
                          <td>{time}*</td> 
                          <td>{time_utc}</td> 
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                      
            </div>
          }

        </div>
      </section>
  );
};
export default StatusInfo;